/**
 * 엑셀 다운로드 버튼 컴포넌트
 * 엑셀 아이콘이 포함된 다운로드 버튼을 렌더링합니다.
 */

interface Props extends React.HTMLAttributes<HTMLButtonElement> {}

function ExcelDownloadButton({ children, ...props }: Props) {
  return (
    <button {...props} className="base-btn color-white icon-excel">
      {children}
    </button>
  );
}
export default ExcelDownloadButton;
